module.exports = __webpack_public_path__ + "static/google-merchant-center-errors-19a9a1e69fbff444590dcf8e668db4c5.jpg";